import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Details from '../Pages/Details/Details';

const ServiceDetails = () => {
    const {detailsId}= useParams();
    const [fullDetails, setFullDetails]=useState([]);
    useEffect(()=>{
        fetch('/fakeData.json')
        .then(res=>res.json())
        .then(data=>setFullDetails(data))
    },[])
    const detail= fullDetails.find(detail=> detail.id == detailsId);
    console.log(detail)
    return (
        <div className="container">
            
            <div className="card h-100 m-5">
      <img src={detail?.img} className="card-img-top" alt="..."/>
      <div className="card-body">
      <h3>Id:{detail?.id}</h3>
        <h5 className="card-title">{detail?.name}</h5>
         <h5>{detail?.title}</h5>
         <h5>Nationality: {detail?.nationality}</h5>
         <h5>Position: {detail?.position}</h5>
         <h6>Contact: {detail?.contact}</h6>

        <p className="card-text">{detail?.description}</p>
      </div>
      <div className="card-footer">
        <small className="text-muted">Last updated 3 mins ago</small>
      </div>
    </div>
 
        </div>
    );
};

export default ServiceDetails;